import { render, staticRenderFns } from "./ConnectAccount.vue?vue&type=template&id=2ec7f357"
import script from "./ConnectAccount.vue?vue&type=script&lang=js"
export * from "./ConnectAccount.vue?vue&type=script&lang=js"
import style0 from "./ConnectAccount.vue?vue&type=style&index=0&id=2ec7f357&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports